import classNames from "classnames";
import { useState } from "react";

import TranscriptIcon from "@/icons/transcript.svg";

import { TabsContent, TabsInterface } from "./Tabs.interface";
import styles from "./Tabs.module.scss";
import Description from "./TabContent/Description";
import Tracklist from "./TabContent/Tracklist";
import Transcript from "./TabContent/Transcript";

const Tabs: React.FC<TabsInterface> = ({
  tracklist,
  description,
  transcript,
  tags,
  slug,
  authors,
  title,
  className,
}) => {
  const [activeTab, setActiveTab] = useState<TabsContent>("description");
  const isTracklist = !!tracklist?.length;
  const isTranscript = transcript && transcript.blocks.length > 1;
  const isMoreTabs = isTracklist || isTranscript;

  const changeTab = (contentType: TabsContent) => {
    setActiveTab(contentType);
  };

  return (
    <section className={classNames(styles.tabs, className)}>
      <div className={styles.buttons}>
        <button
          onClick={() => changeTab("description")}
          className={classNames(
            styles.button,
            isMoreTabs
              ? activeTab === "description" && styles.active
              : styles.tabTitle
          )}
        >
          Opis epizodu
        </button>
        {isTranscript && (
          <button
            onClick={() => changeTab("transcript")}
            className={classNames(
              styles.button,
              activeTab === "transcript" && styles.active
            )}
          >
            <TranscriptIcon />
            Transkrypcja
          </button>
        )}
        {isTracklist && (
          <button
            onClick={() => changeTab("tracklist")}
            className={classNames(
              styles.button,
              activeTab === "tracklist" && styles.active
            )}
          >
            Tracklista
          </button>
        )}
      </div>

      <Description
        description={description}
        tags={tags}
        className={activeTab === "description" && styles.visible}
      />
      {isTracklist && (
        <Tracklist
          tracklist={tracklist}
          slug={slug}
          className={activeTab === "tracklist" && styles.visible}
        />
      )}
      {isTranscript && (
        <Transcript
          transcript={transcript}
          className={activeTab === "transcript" && styles.visible}
          tags={tags}
          authors={authors}
          title={title}
        />
      )}
    </section>
  );
};

export default Tabs;
